import { normalizeBookingSearchDates } from "../utils/bookingSearchDates";

const STORAGE_KEY = "ecoTourCartState";

export const loadState = () => {
  if (typeof window === "undefined") return undefined;
  try {
    const serialized = window.localStorage.getItem(STORAGE_KEY);
    if (!serialized) return undefined;
    const parsed = JSON.parse(serialized);
    const nextState = {};
    if (parsed?.userBookings) nextState.userBookings = parsed.userBookings;
    if (parsed?.landingSearch) {
      const normalizedDates = normalizeBookingSearchDates({
        mode: parsed.landingSearch?.mode,
        startDate: parsed.landingSearch?.dates?.startDate,
        endDate: parsed.landingSearch?.dates?.endDate,
      });
      nextState.landingSearch = {
        ...parsed.landingSearch,
        dates: {
          ...(parsed.landingSearch?.dates || {}),
          ...normalizedDates,
        },
      };
    }
    return Object.keys(nextState).length ? nextState : undefined;
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  if (typeof window === "undefined") return;
  try {
    const payload = {};
    if (state?.userBookings) payload.userBookings = state.userBookings;
    if (state?.landingSearch) payload.landingSearch = state.landingSearch;
    if (Object.keys(payload).length) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
  } catch (error) {
    // ignore write errors (private browsing, quota, etc.)
  }
};
